import { Badge } from '@/components/ui/badge';
import { Play, Upload, Wand2, Rocket, ArrowRight } from 'lucide-react';

const steps = [
  { icon: Upload, label: 'Upload photos' },
  { icon: Wand2, label: 'AI enhances & writes' },
  { icon: Rocket, label: 'Publish everywhere' },
];

export function DemoVideosSection() {
  return (
    <section className="relative py-20 lg:py-32 overflow-hidden bg-gradient-to-b from-muted/30 via-muted/15 to-background">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10 lg:mb-12">
          <Badge variant="outline" className="mb-4">
            <Play className="w-4 h-4 mr-2" />
            Full Walkthrough
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold mb-4">
            Watch ListBright in Action
          </h2>
          <p className="text-muted-foreground text-lg">
            From a few phone photos to a polished, multi-language listing — published in minutes.
          </p>
        </div>

        {/* Step rail — gives this section a distinct "workflow" rhythm */}
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-3 sm:gap-x-6 mb-12">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <div key={step.label} className="flex items-center gap-3 sm:gap-6">
                <div className="flex items-center gap-2.5">
                  <div className="flex items-center justify-center w-9 h-9 rounded-full bg-card border border-border/60 shadow-sm">
                    <Icon className="w-4 h-4 text-primary" />
                  </div>
                  <span className="text-sm font-medium">
                    <span className="text-muted-foreground mr-1.5 tabular-nums">0{i + 1}</span>
                    {step.label}
                  </span>
                </div>
                {i < steps.length - 1 && (
                  <ArrowRight className="hidden sm:block w-4 h-4 text-muted-foreground/40" />
                )}
              </div>
            );
          })}
        </div>

        <div className="relative" data-tour="demo-videos">
          {/* Cinematic glow effect */}
          <div className="absolute -inset-4 bg-gradient-to-t from-primary/10 via-accent/5 to-transparent blur-3xl rounded-[2.5rem] opacity-60 pointer-events-none" />

          {/* Video container matched to the promo's native widescreen ratio */}
          <div className="relative rounded-2xl lg:rounded-3xl overflow-hidden shadow-elevated border border-border/50 bg-card">
            <iframe
              src="/listbright-promo.player.htm"
              title="ListBright Promo"
              loading="lazy"
              className="block w-full aspect-video border-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
